import cn from 'classnames';

type Props = React.ComponentPropsWithRef<'label'> & {
  className?: string;
  children: React.ReactNode;
};

/**
 * This component can be used just like a normal html <label> element.
 * It is a react component only to ensure consistent styling
 */
export function Label({ children, className, ...htmlProps }: Props) {
  return (
    // biome-ignore lint/a11y/noLabelWithoutControl: The label will be associated with a control element via props.
    <label className={cn('label', className)} {...htmlProps}>
      {children}
    </label>
  );
}
